import React from 'react'

export const LoginPage: React.FC = (): React.ReactElement => <h1>Login page</h1>
